module.exports = __webpack_public_path__ + "static/img/pressure-logo.19b2afe6.png";